'use client';

import { createContext } from 'react';

// ----------------------------------------------------------------------

export const SettingsContext = createContext(undefined);
